// extracted by mini-css-extract-plugin
module.exports = {"rootContainer":"customer-summary-component_rootContainer__3mToH","label":"customer-summary-component_label__2cY0C"};